import { z } from "zod";

import { MediumSchema, PurposeSchema } from "./shared";

export const AppointmentV1Schema = z.object({
  end_time: z.string(),
  ics_url: z.string(),
  id: z.number(),
  location: z.string().nullable(),
  medium: MediumSchema,
  patient_first_name: z.string(),
  patient_id: z.number(),
  patient_last_name: z.string(),
  patient_number: z.string(),
  patient_preferred_name: z.string(),
  purpose: PurposeSchema,
  start_time: z.string(),
  state: z.string().nullable(),
  state_v2: z.string().nullable(),
});
export type AppointmentV1 = z.infer<typeof AppointmentV1Schema>;

const PostAppointmentV1PayloadSchema = z.object({
  end_time: z.string(),
  health_care_professional_id: z.number(),
  location: z.string().nullable(),
  medium: MediumSchema,
  patient_id: z.number(),
  purpose: PurposeSchema,
  start_time: z.string(),
});
export type PostAppointmentV1Payload = z.infer<typeof PostAppointmentV1PayloadSchema>;

const PostAppointmentV1ArgsSchema = z.object({
  body: PostAppointmentV1PayloadSchema,
});
export type PostAppointmentV1Args = z.infer<typeof PostAppointmentV1ArgsSchema>;
